import React from 'react';
import SearchForm from "../SearchForm/SearchForm";
import './SearchModal.css';

class SearchModal extends React.Component
{
  state = {
    visible: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState({
        visible: this.props.visible
      });


    }
  }

  render() {
    const classes = ['modal'];
    if (this.state.visible) {
      classes.push('modal--visible');
    }
    return (
      <div className={classes.join(' ')}>
        <button className="button button--close" onClick={ this.props.onClickClose }>Close</button>
        <div className="search">
          <h1>Search in delta-elektronika.nl</h1>
          <SearchForm index={ this.props.index } focusInput={ this.state.visible } />
        </div>
      </div>
    );
  }
}

export default SearchModal;
